<template>

	<div class="leaving-monitor">


		<div class="row">

			<div class="col-md-8">

				<h3 class="page-title" v-translate>Monitor de Saída</h3>

			</div>

			<div class="col-md-4 text-right">

				<!-- <button type="button" class="btn btn-circle btn-icon-only btn-default fullscreen" @click="fullscreen">
					<i class="fa fa-desktop" aria-hidden="true"></i>
				</button> -->

			</div>

		</div>

		<div class="portlet light">

			<div class="portlet-title">

				<div class="caption">

					<span class="caption-subject bold uppercase pull-left" v-show="paginateCollection.data && paginateCollection.data.length">

						<span>Página {{ paginateCollection.currentPage }} (</span>
						<span v-if="paginateCollection.total >= 10">{{ paginateCollection.perPage }}</span>
						<span v-if="paginateCollection.total < 10">{{ paginateCollection.total }}</span>
						<span>de {{ paginateCollection.total }} alunos )</span>

					</span>

				</div>

				<div class="actions">

					<clock class="pull-right clock" :displaySeconds="true"/>

				</div>

			</div>

			<div class="portlet-body">

				<div class="row">

					<div class="col-md-12" v-show="paginateCollection.data && paginateCollection.data.length">

						<div class="table-responsive">

							<table class="table table-bordered table-striped m-b-0">

								<thead>
									<tr>
										<th class="bold align-middle" v-translate>Nome do Aluno</th>
										<th class="bold align-middle" v-translate>Quem irá buscar?</th>
										<th class="bold align-middle" v-translate>Turma</th>
										<th class="bold align-middle" colspan="2" v-translate>Previsão de Chegada</th>
									</tr>
								</thead>

								<tbody>

									<tr class="has-arrived" v-for="student in paginateCollection.data">

										<td width="25%" class="align-middle">

											<img class="img-circle" :src="student.student.photoURL">
											<span>{{ student.student.name }}</span>

										</td>

										<td width="25%" class="align-middle">

											<span v-if="student.delegateToSomeone === false">{{ student.responsible.name }}</span>
											<span v-if="student.delegateToSomeone === true">
												{{ student.delegatedToName }}<br>
												<small class="text-muted" v-translate>Autorizado por: {{ student.responsible.name }}</small>
											</span>

										</td>

										<td width="20%" class="align-middle">{{ student.schoolClass.description }}</td>

										<td width="20%" class="align-middle">

											<span v-if="student.delegatedEstimatedTimeToPickup"> {{ student.delegatedEstimatedTimeToPickup | now }}</span>
											<span v-if="student.estimatedArrivedDateTime">{{ student.estimatedArrivedDateTime | now }}</span>
											<span v-if="student.arrivedDateTime" v-translate>CHEGOU</span>
											<span v-if="!student.delegatedEstimatedTimeToPickup && !student.estimatedArrivedDateTime && !student.arrivedDateTime" v-translate>Não disponível</span>

										</td>


										<td width="5%" class="align-middle">

											<button type="button" class="btn green-meadow" @click="removeStudentItem(student)" v-translate>Aluno liberado</button>

										</td>

									</tr>

								</tbody>

							</table>

						</div>

					</div>

					<div class="col-md-12" v-show="paginateCollection.data && !paginateCollection.data.length">

						<div class="alert alert-info text-center" v-translate>
							Aguardando notificação dos pais para liberar saída
						</div>

					</div>

				</div>

			</div>

		</div>

	</div>

</template>

<script>

	import LeavingMonitor from './';
	export default LeavingMonitor;

</script>

<style lang="scss" scoped>

	html,
	body {
		height: 100%;
	}

	.leaving-monitor {
		padding: 1em;
	}

	.alert-info {
		font-size: 2em;
	}

	small {
		font-size: .7em;
	}

	@keyframes has-arrived {
		0%   {background-color: #1BBC9B;
			color: white;
		}
		50%  {background-color: white}
	}

	.has-arrived {
		width: 100px;
		height: 100px;
		animation-name: has-arrived;
		animation-duration: 3s;
		animation-iteration-count: 6;
	}

	.has-arrived .text-right {
		font-weight: bold;
		color: #1BBC9B;
	}

	.img-circle {
		width: 45px;
		height: 45px;
	}

	.table {

		&.table-monitor {
			font-size: 20px;
			color: grey;
		}

		th,
		td {
			font-size: 1.4em;
			height: 70px;
		}

	}

	.clock {
		color: #2ab4c0;
		font-weight: bold;
		font-size: 30px;
	}

</style>



// WEBPACK FOOTER //
// leaving-monitor.vue?5204019c